module.exports = __webpack_public_path__ + "img/alashkert.efc0e4b7.png";